module.exports = __webpack_public_path__ + "img/sba-expert-guidance.56ae29d.png";